<section class="w-full flex flex-col">
       
    <div class="w-full p-6 relative h-[400px] bg-cover  bg-no-repeat bg-center flex flex-col justify-center "   [ngStyle]="{ 'background-image': getBackgroundImage(activeTabIndex)}">
          <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
          <!-- <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase "> {{view.page?.content.name}} </h1> -->

          <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase border-b-2 border-primary-700 max-w-96">{{ getTitle(activeTabIndex) }}</h1>
          <!-- <span class="w-60 border-b-4 border-primary-700 "></span> -->
          <p class="z-10 text-nm text-white font-light max-w-[600px] pt-2">{{ getDescription(activeTabIndex) }} </p>
  </div>

  <div class="w-full overflow-hidden">
    <mat-tab-group  backgroundColor="primary"  class="overflow-x-auto whitespace-nowrap flex"  (selectedTabChange)="onTabChange($event)" >
      <mat-tab label="Cunard">
        <ng-template matTabContent>
          <div class="w-full p-4">
               <gallery-images></gallery-images>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="Hurtigruten">
        <ng-template matTabContent>
          <div class="w-full p-4">
               <gallery-images></gallery-images>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="P&O Cruises">
        <ng-template matTabContent>
          <div class="w-full p-4">
               <gallery-images></gallery-images>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="Seabourn">
        <ng-template matTabContent>
          <div class="w-full p-4">
               <gallery-images></gallery-images>
          </div>
        </ng-template>
      </mat-tab>
      <!-- Add more tabs as needed -->
    </mat-tab-group>
  </div>
  <app-footer-type03></app-footer-type03>

</section>
